import { showToast } from '@shared/components';
import { TOAST_TYPES } from '@shared/constants';
import { getToken, decodeToken } from '@utils';
import { RingCentralService } from '@consumers/services';
import config from '@config';

/**
 *
 * @param {string} accountUid - Account uid for jwks generation
 * @param {function} setJwksToken - Workspace Context **setJwksToken** setter function, to update
 * token directly in context
 */

let isFetchingJwks = false;

export const getJWKS = async (accountUid, callBack) => {
  const userData = decodeToken(getToken());

  if (
    (userData &&
      userData.role === 'Customer' &&
      !config.rcApiBaseUrl.includes('devtest')) ||
    isFetchingJwks
  ) {
    return { data: null, error: null };
  }
  isFetchingJwks = true;
  const { data, error } = await RingCentralService.getAccountJwksToken(
    accountUid
  );

  if (error) {
    isFetchingJwks = false;
    // showToast(
    //   Array.isArray(error) ? error[0].message : error,
    //   TOAST_TYPES.ERROR
    // );
    return {
      data: null,
      error,
    };
  }

  if (callBack) {
    callBack(data, accountUid);
  }
  isFetchingJwks = false;
  return {
    data: data,
    error: null,
  };
};

export const isJwksRequired = () => {
  const userData = decodeToken(getToken());

  if (
    userData &&
    userData.role === 'Customer' &&
    !config.rcApiBaseUrl.includes('devtest')
  ) {
    return false;
  }

  return true;
};
